import { MESSAGES } from 'portal/src/constants/snackbarMessages';
import { ValidatorBody } from 'portal/src/validators/validateGuard';

export class AddFacilityFormValidators {
  getValues;

  constructor(getValues) {
    this.getValues = getValues;
  }

  /**
   * Return an array validator to guards control with validate function that return a single boolean
   * @returns {Array<ValidatorBody<boolean>>}
   */
  getServiceTypesValidator(): ValidatorBody<boolean>[] {
    const values = this.getValues();
    return [
      {
        message: MESSAGES.BUDGET.ONE_SERVICE_TYPE_REQUIRED,
        validate: () => !!values.serviceTypes && values.serviceTypes.length > 0,
      },
    ];
  }
}
